module.exports = __webpack_public_path__ + "img/product_book.b51e672d.png";